/* ==========================================================================
   Gift Delivery & Pickup Form — Top Knot
   Phase 2-5: gift checkbox, fulfillment, delivery fields, split order
   Phase 6a: HARD validation on checkout + stale attribute cleanup on mode switch
   Phase 8: cart-change sync + orphaned attribute cleanup
   Sydney R1: Delivery Recipient field (required)
   Sydney R2: Delivery Date field (required, date picker → MM/DD/YYYY) — All Delivery + Split per-item
   ========================================================================== */
(function () {
  'use strict';

  function updateCartAttribute(key, value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [key]: value } }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart update failed: ' + res.status);
        return res.json();
      })
      .catch(function (err) {
        console.error('[gift-form] attribute update error:', err);
      });
  }

  function debounce(fn, wait) {
    let t;
    return function () {
      const args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Convert HTML date input value (YYYY-MM-DD) to MM/DD/YYYY for admin display
  function formatDate(isoValue) {
    if (!isoValue) return '';
    var parts = isoValue.split('-'); // [YYYY, MM, DD]
    if (parts.length !== 3) return isoValue;
    return parts[1] + '/' + parts[2] + '/' + parts[0];
  }
  // Convert MM/DD/YYYY back to YYYY-MM-DD (to restore into the date input)
  function toISODate(usValue) {
    if (!usValue) return '';
    var parts = usValue.split('/'); // [MM, DD, YYYY]
    if (parts.length !== 3) return usValue;
    return parts[2] + '-' + parts[0] + '-' + parts[1];
  }

  var DESTINATIONS = [
    'DES — DeWitt Elementary School',
    'DMS — DeWitt Middle School',
    'DHS — DeWitt High School',
    'Pattillo',
    'Belleville Shoe Factory',
    "Registrant's Shower",
    'Call Registrant for Pick Up',
    'Other Business or Address'
  ];
  var OCCASIONS = ['Birthday', 'Just Because', 'Wedding', 'Baby', 'Other'];

  function initGiftForm() {
    const wrapper = document.querySelector('[data-gift-form]');
    if (!wrapper) return;

    if (wrapper.dataset.giftInit === 'true') return;
    wrapper.dataset.giftInit = 'true';

    let currentAttributes = {};

    const checkbox = wrapper.querySelector('[data-gift-checkbox]');
    const body = wrapper.querySelector('[data-gift-body]');
    const fulfillmentRadios = wrapper.querySelectorAll('[data-fulfillment-radio]');
    const deliverySection = wrapper.querySelector('[data-delivery-section]');
    const splitSection = wrapper.querySelector('[data-split-section]');

    const recipient = wrapper.querySelector('[data-recipient]');
    const deliveryDate = wrapper.querySelector('[data-delivery-date]');
    const destination = wrapper.querySelector('[data-destination]');
    const desFields = wrapper.querySelector('[data-des-fields]');
    const otherFields = wrapper.querySelector('[data-other-fields]');
    const gradeInput = wrapper.querySelector('[data-grade]');
    const teacherInput = wrapper.querySelector('[data-teacher]');
    const otherAddress = wrapper.querySelector('[data-other-address]');

    const occasion = wrapper.querySelector('[data-occasion]');
    const occasionOtherField = wrapper.querySelector('[data-occasion-other-field]');
    const occasionOther = wrapper.querySelector('[data-occasion-other]');

    const cardMessage = wrapper.querySelector('[data-card-message]');
    const otherNotes = wrapper.querySelector('[data-other-notes]');

    const splitItemsContainer = wrapper.querySelector('[data-split-items]');

    if (!checkbox || !body) return;

    function applyFulfillmentUI(value) {
      if (deliverySection) deliverySection.hidden = value !== 'All Delivery';
      if (splitSection) splitSection.hidden = value !== 'Split Order';
    }

    function applyDestinationUI(value) {
      const isDES = value === 'DES — DeWitt Elementary School';
      const isOther = value === 'Other Business or Address';
      if (desFields) desFields.hidden = !isDES;
      if (otherFields) otherFields.hidden = !isOther;
    }

    function applyOccasionUI(value) {
      if (occasionOtherField) occasionOtherField.hidden = value !== 'Other';
    }

    function keyFor(item) {
      const title = item.product_title || item.title || 'Item';
      return 'Item: ' + title;
    }

    function buildItemDeliveryFields(base, attrs) {
      var destOpts = '<option value="" disabled selected>Select a destination…</option>';
      DESTINATIONS.forEach(function (d) {
        destOpts += '<option value="' + escapeHtml(d) + '">' + escapeHtml(d) + '</option>';
      });
      var occOpts = '<option value="" disabled selected>Select an occasion…</option>';
      OCCASIONS.forEach(function (o) {
        occOpts += '<option value="' + escapeHtml(o) + '">' + escapeHtml(o) + '</option>';
      });

      return '' +
        '<div class="gift-form__field">' +
          '<label class="gift-form__label">Delivery Recipient <span class="gift-form__required">*</span></label>' +
          '<input class="gift-form__input" type="text" data-item-recipient placeholder="First and Last Name">' +
        '</div>' +
        '<div class="gift-form__field">' +
          '<label class="gift-form__label">Delivery Date <span class="gift-form__required">*</span></label>' +
          '<input class="gift-form__input" type="date" data-item-delivery-date>' +
        '</div>' +
        '<div class="gift-form__field">' +
          '<label class="gift-form__label">Delivery Destination <span class="gift-form__required">*</span></label>' +
          '<select class="gift-form__select" data-item-destination>' + destOpts + '</select>' +
        '</div>' +
        '<div class="gift-form__subfields" data-item-des-fields hidden>' +
          '<div class="gift-form__field"><label class="gift-form__label">Grade <span class="gift-form__optional">(optional)</span></label>' +
          '<input class="gift-form__input" type="text" data-item-grade placeholder="e.g. Grade 3"></div>' +
          '<div class="gift-form__field"><label class="gift-form__label">Teacher <span class="gift-form__optional">(optional)</span></label>' +
          '<input class="gift-form__input" type="text" data-item-teacher placeholder="e.g. Mrs. Smith"></div>' +
        '</div>' +
        '<div class="gift-form__subfields" data-item-other-fields hidden>' +
          '<div class="gift-form__field"><label class="gift-form__label">Business or Address</label>' +
          '<input class="gift-form__input" type="text" data-item-other-address placeholder="Enter business name or address">' +
          '<p class="gift-form__note">Note: Delivery is within city limits only.</p></div>' +
        '</div>' +
        '<div class="gift-form__field">' +
          '<label class="gift-form__label">Occasion <span class="gift-form__required">*</span></label>' +
          '<select class="gift-form__select" data-item-occasion>' + occOpts + '</select>' +
        '</div>' +
        '<div class="gift-form__subfields" data-item-occasion-other-field hidden>' +
          '<div class="gift-form__field"><label class="gift-form__label">Please specify the occasion</label>' +
          '<input class="gift-form__input" type="text" data-item-occasion-other placeholder="Enter occasion"></div>' +
        '</div>' +
        '<div class="gift-form__field"><label class="gift-form__label">Card Message <span class="gift-form__optional">(optional)</span></label>' +
          '<textarea class="gift-form__textarea" data-item-card-message rows="3" placeholder="Write your card message here"></textarea></div>' +
        '<div class="gift-form__field"><label class="gift-form__label">Other Notes <span class="gift-form__optional">(optional)</span></label>' +
          '<textarea class="gift-form__textarea" data-item-other-notes rows="3" placeholder="Any other instructions for your order"></textarea></div>';
    }

    function wireItemDeliveryFields(fieldsBox, base, attrs) {
      var recipientEl = fieldsBox.querySelector('[data-item-recipient]');
      var dateEl = fieldsBox.querySelector('[data-item-delivery-date]');
      var destSel = fieldsBox.querySelector('[data-item-destination]');
      var desBox = fieldsBox.querySelector('[data-item-des-fields]');
      var otherBox = fieldsBox.querySelector('[data-item-other-fields]');
      var gradeEl = fieldsBox.querySelector('[data-item-grade]');
      var teacherEl = fieldsBox.querySelector('[data-item-teacher]');
      var otherAddrEl = fieldsBox.querySelector('[data-item-other-address]');
      var occSel = fieldsBox.querySelector('[data-item-occasion]');
      var occOtherBox = fieldsBox.querySelector('[data-item-occasion-other-field]');
      var occOtherEl = fieldsBox.querySelector('[data-item-occasion-other]');
      var cardEl = fieldsBox.querySelector('[data-item-card-message]');
      var notesEl = fieldsBox.querySelector('[data-item-other-notes]');

      var kRecipient = base + ' — Delivery Recipient';
      var kDate = base + ' — Delivery Date';
      var kDest = base + ' — Delivery Destination';
      var kGrade = base + ' — Grade';
      var kTeacher = base + ' — Teacher';
      var kOcc = base + ' — Occasion';
      var kCard = base + ' — Card Message';
      var kNotes = base + ' — Other Notes';

      function applyDestUI(v) {
        if (desBox) desBox.hidden = v !== 'DES — DeWitt Elementary School';
        if (otherBox) otherBox.hidden = v !== 'Other Business or Address';
      }
      function applyOccUI(v) {
        if (occOtherBox) occOtherBox.hidden = v !== 'Other';
      }

      if (recipientEl) recipientEl.value = attrs[kRecipient] || '';
      if (dateEl) dateEl.value = toISODate(attrs[kDate] || '');

      var savedDest = attrs[kDest] || '';
      if (savedDest && destSel) {
        var destMatch = [].slice.call(destSel.options).some(function (o) { return o.value === savedDest; });
        if (destMatch) {
          destSel.value = savedDest;
          applyDestUI(savedDest);
        } else {
          destSel.value = 'Other Business or Address';
          applyDestUI('Other Business or Address');
          if (otherAddrEl) otherAddrEl.value = savedDest;
        }
      }
      if (gradeEl) gradeEl.value = attrs[kGrade] || '';
      if (teacherEl) teacherEl.value = attrs[kTeacher] || '';

      var savedOcc = attrs[kOcc] || '';
      if (savedOcc && occSel) {
        var occMatch = [].slice.call(occSel.options).some(function (o) { return o.value === savedOcc; });
        if (occMatch) {
          occSel.value = savedOcc;
          applyOccUI(savedOcc);
        } else {
          occSel.value = 'Other';
          applyOccUI('Other');
          if (occOtherEl) occOtherEl.value = savedOcc;
        }
      }
      if (cardEl) cardEl.value = attrs[kCard] || '';
      if (notesEl) notesEl.value = attrs[kNotes] || '';

      if (recipientEl) recipientEl.addEventListener('input', debounce(function () { updateCartAttribute(kRecipient, recipientEl.value); }, 600));
      if (dateEl) dateEl.addEventListener('change', function () { updateCartAttribute(kDate, formatDate(dateEl.value)); });
      if (destSel) {
        destSel.addEventListener('change', function () {
          var v = destSel.value;
          applyDestUI(v);
          if (v === 'Other Business or Address') {
            updateCartAttribute(kDest, otherAddrEl && otherAddrEl.value ? otherAddrEl.value : v);
          } else {
            updateCartAttribute(kDest, v);
          }
        });
      }
      if (gradeEl) gradeEl.addEventListener('input', debounce(function () { updateCartAttribute(kGrade, gradeEl.value); }, 600));
      if (teacherEl) teacherEl.addEventListener('input', debounce(function () { updateCartAttribute(kTeacher, teacherEl.value); }, 600));
      if (otherAddrEl) otherAddrEl.addEventListener('input', debounce(function () { updateCartAttribute(kDest, otherAddrEl.value || 'Other Business or Address'); }, 600));
      if (occSel) {
        occSel.addEventListener('change', function () {
          var v = occSel.value;
          applyOccUI(v);
          if (v === 'Other') {
            updateCartAttribute(kOcc, occOtherEl && occOtherEl.value ? occOtherEl.value : 'Other');
          } else {
            updateCartAttribute(kOcc, v);
          }
        });
      }
      if (occOtherEl) occOtherEl.addEventListener('input', debounce(function () { updateCartAttribute(kOcc, occOtherEl.value || 'Other'); }, 600));
      if (cardEl) cardEl.addEventListener('input', debounce(function () { updateCartAttribute(kCard, cardEl.value); }, 600));
      if (notesEl) notesEl.addEventListener('input', debounce(function () { updateCartAttribute(kNotes, notesEl.value); }, 600));
    }

    function renderSplitItems(cart) {
      if (!splitItemsContainer) return;
      const items = cart.items || [];
      const attrs = cart.attributes || {};

      splitItemsContainer.innerHTML = '';

      items.forEach(function (item, idx) {
        const base = keyFor(item);
        const fulfillKey = base + ' — Fulfillment';
        const savedFulfill = attrs[fulfillKey] || '';

        const block = document.createElement('div');
        block.className = 'split-item';
        block.setAttribute('data-split-item', '');
        block.setAttribute('data-item-key', base);

        const imgUrl = item.image ? item.image.replace(/(\.[^.?]+)(\?|$)/, '_80x$1$2') : '';
        const img = imgUrl
          ? '<img class="split-item__img" src="' + imgUrl + '" alt="" width="48" height="48">'
          : '';

        block.innerHTML =
          '<div class="split-item__head">' +
            img +
            '<span class="split-item__title">' + escapeHtml(item.product_title || item.title) + '</span>' +
          '</div>' +
          '<div class="split-item__pills">' +
            '<label class="gift-pill gift-pill--sm">' +
              '<input type="radio" name="split-' + idx + '" value="Pick Up" data-split-fulfillment>' +
              '<span class="gift-pill__label">Pick Up</span>' +
            '</label>' +
            '<label class="gift-pill gift-pill--sm">' +
              '<input type="radio" name="split-' + idx + '" value="Delivery" data-split-fulfillment>' +
              '<span class="gift-pill__label">Delivery</span>' +
            '</label>' +
          '</div>' +
          '<div class="split-item__fields" data-split-fields hidden>' +
            buildItemDeliveryFields(base, attrs) +
          '</div>';

        splitItemsContainer.appendChild(block);

        const radios = block.querySelectorAll('[data-split-fulfillment]');
        const fieldsBox = block.querySelector('[data-split-fields]');

        if (fieldsBox) wireItemDeliveryFields(fieldsBox, base, attrs);

        radios.forEach(function (radio) {
          if (radio.value === savedFulfill) {
            radio.checked = true;
            if (fieldsBox) fieldsBox.hidden = radio.value !== 'Delivery';
          }
          radio.addEventListener('change', function () {
            if (!radio.checked) return;
            if (fieldsBox) fieldsBox.hidden = radio.value !== 'Delivery';
            updateCartAttribute(fulfillKey, radio.value);
          });
        });
      });
    }

    // Restore state on load
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const attrs = cart.attributes || {};
        currentAttributes = attrs;

        const isGift = attrs['Is this a gift?'] === 'Yes';
        checkbox.checked = isGift;
        body.hidden = !isGift;

        const savedFulfillment = attrs['Fulfillment Type'];
        if (savedFulfillment) {
          fulfillmentRadios.forEach(function (radio) {
            if (radio.value === savedFulfillment) radio.checked = true;
          });
          applyFulfillmentUI(savedFulfillment);
          if (savedFulfillment === 'Split Order') renderSplitItems(cart);
        }

        if (recipient) recipient.value = attrs['Delivery Recipient'] || '';
        if (deliveryDate) deliveryDate.value = toISODate(attrs['Delivery Date'] || '');

        if (destination) {
          const savedDest = attrs['Delivery Destination'] || '';
          if (savedDest) {
            const matchOption = [].slice.call(destination.options).some(function (o) {
              return o.value === savedDest;
            });
            if (matchOption) {
              destination.value = savedDest;
              applyDestinationUI(savedDest);
            } else {
              destination.value = 'Other Business or Address';
              applyDestinationUI('Other Business or Address');
              if (otherAddress) otherAddress.value = savedDest;
            }
          }
          if (gradeInput) gradeInput.value = attrs['Grade'] || '';
          if (teacherInput) teacherInput.value = attrs['Teacher'] || '';
        }

        if (occasion) {
          const savedOcc = attrs['Occasion'] || '';
          if (savedOcc) {
            const matchOcc = [].slice.call(occasion.options).some(function (o) {
              return o.value === savedOcc;
            });
            if (matchOcc) {
              occasion.value = savedOcc;
              applyOccasionUI(savedOcc);
            } else {
              occasion.value = 'Other';
              applyOccasionUI('Other');
              if (occasionOther) occasionOther.value = savedOcc;
            }
          }
        }

        if (cardMessage) cardMessage.value = attrs['Card Message'] || '';
        if (otherNotes) otherNotes.value = attrs['Other Notes'] || '';
      });

    checkbox.addEventListener('change', function () {
      const isGift = checkbox.checked;
      body.hidden = !isGift;
      updateCartAttribute('Is this a gift?', isGift ? 'Yes' : 'No');
    });

    // ===== Stale attribute cleanup on mode switch =====
    function clearModeAttributes(keepMode) {
      const allDeliveryKeys = ['Delivery Recipient', 'Delivery Date', 'Delivery Destination', 'Grade', 'Teacher', 'Occasion', 'Card Message', 'Other Notes'];
      const updates = {};
      if (keepMode !== 'All Delivery') {
        allDeliveryKeys.forEach(function (k) { updates[k] = ''; });
      }
      if (Object.keys(updates).length) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: updates }),
        });
      }
    }


    // ===== Phase 8: remove attributes for items no longer in cart =====
    function cleanOrphanedItemAttributes(cart) {
      const attrs = cart.attributes || {};
      const items = cart.items || [];

      const validBases = items.map(function (item) { return keyFor(item); });

      const updates = {};
      Object.keys(attrs).forEach(function (key) {
        if (key.indexOf('Item: ') === 0 && key.indexOf(' — ') !== -1) {
          const base = key.substring(0, key.indexOf(' — '));
          if (validBases.indexOf(base) === -1) {
            updates[key] = '';
          }
        }
      });

      if (Object.keys(updates).length) {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: updates }),
        }).then(function (r) { return r.json(); });
      }
      return Promise.resolve(cart);
    }

    // ===== Phase 6a: validation helpers =====
    function clearErrors() {
      wrapper.querySelectorAll('.gift-form__error').forEach(function (el) { el.remove(); });
      wrapper.querySelectorAll('.gift-form__field--error').forEach(function (el) {
        el.classList.remove('gift-form__field--error');
      });
    }

    function showError(fieldEl, message) {
      if (!fieldEl) return;
      const field = fieldEl.closest('.gift-form__field') || fieldEl.parentElement;
      field.classList.add('gift-form__field--error');
      const err = document.createElement('p');
      err.className = 'gift-form__error';
      err.textContent = message;
      field.appendChild(err);
    }

    function validateGiftForm() {
      clearErrors();
      if (!checkbox.checked) return { valid: true };

      let firstError = null;

      const chosenFulfillment = [].slice.call(fulfillmentRadios).find(function (r) { return r.checked; });
      if (!chosenFulfillment) {
        const fieldset = wrapper.querySelector('[data-gift-fulfillment]');
        fieldset.classList.add('gift-form__field--error');
        const err = document.createElement('p');
        err.className = 'gift-form__error';
        err.textContent = 'Please choose how this order should be fulfilled.';
        fieldset.appendChild(err);
        return { valid: false, firstError: fieldset };
      }

      const mode = chosenFulfillment.value;

      if (mode === 'All Delivery') {
        if (recipient && !recipient.value.trim()) {
          showError(recipient, 'Please enter the delivery recipient\'s name.');
          firstError = firstError || recipient;
        }
        if (deliveryDate && !deliveryDate.value) {
          showError(deliveryDate, 'Please select a delivery date.');
          firstError = firstError || deliveryDate;
        }
        if (destination && !destination.value) {
          showError(destination, 'Please select a delivery destination.');
          firstError = firstError || destination;
        }
        if (occasion && !occasion.value) {
          showError(occasion, 'Please select an occasion.');
          firstError = firstError || occasion;
        }
      }

      if (mode === 'Split Order') {
        const itemBlocks = wrapper.querySelectorAll('[data-split-item]');
        itemBlocks.forEach(function (block) {
          const radios = block.querySelectorAll('[data-split-fulfillment]');
          const chosen = [].slice.call(radios).find(function (r) { return r.checked; });
          if (!chosen) {
            const pills = block.querySelector('.split-item__pills');
            pills.classList.add('gift-form__field--error');
            const err = document.createElement('p');
            err.className = 'gift-form__error';
            err.textContent = 'Please choose Delivery or Pick Up for this item.';
            pills.appendChild(err);
            firstError = firstError || pills;
          } else if (chosen.value === 'Delivery') {
            const rec = block.querySelector('[data-item-recipient]');
            const dateItem = block.querySelector('[data-item-delivery-date]');
            const dest = block.querySelector('[data-item-destination]');
            const occ = block.querySelector('[data-item-occasion]');
            if (rec && !rec.value.trim()) {
              showError(rec, 'Please enter the delivery recipient\'s name.');
              firstError = firstError || rec;
            }
            if (dateItem && !dateItem.value) {
              showError(dateItem, 'Please select a delivery date.');
              firstError = firstError || dateItem;
            }
            if (dest && !dest.value) {
              showError(dest, 'Please select a delivery destination.');
              firstError = firstError || dest;
            }
            if (occ && !occ.value) {
              showError(occ, 'Please select an occasion.');
              firstError = firstError || occ;
            }
          }
        });
      }

      return { valid: !firstError, firstError: firstError };
    }

   // ===== Phase 6a: intercept checkout (form submit is most reliable) =====
    const cartForm = document.querySelector('#cart') || document.querySelector('form[action*="/cart"]');
    if (cartForm) {
      cartForm.addEventListener('submit', function (e) {
        const result = validateGiftForm();
        if (!result.valid) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (result.firstError) {
            result.firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }, true);
    }

    const checkoutBtn = document.querySelector('#checkout');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        const result = validateGiftForm();
        if (!result.valid) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (result.firstError) {
            result.firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }, true);
    }

    // Fulfillment type selection (with cleanup + error clear)
    fulfillmentRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        clearErrors();
        applyFulfillmentUI(radio.value);
        updateCartAttribute('Fulfillment Type', radio.value);
        clearModeAttributes(radio.value);
        if (radio.value === 'Split Order') {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(renderSplitItems);
        }
      });
    });

    // All Delivery field listeners
    if (recipient) recipient.addEventListener('input', debounce(function () { updateCartAttribute('Delivery Recipient', recipient.value); }, 600));
    if (deliveryDate) deliveryDate.addEventListener('change', function () { updateCartAttribute('Delivery Date', formatDate(deliveryDate.value)); });
    if (destination) {
      destination.addEventListener('change', function () {
        const value = destination.value;
        applyDestinationUI(value);
        if (value === 'Other Business or Address') {
          updateCartAttribute('Delivery Destination', otherAddress && otherAddress.value ? otherAddress.value : value);
        } else {
          updateCartAttribute('Delivery Destination', value);
        }
      });
    }
    if (gradeInput) gradeInput.addEventListener('input', debounce(function () { updateCartAttribute('Grade', gradeInput.value); }, 600));
    if (teacherInput) teacherInput.addEventListener('input', debounce(function () { updateCartAttribute('Teacher', teacherInput.value); }, 600));
    if (otherAddress) otherAddress.addEventListener('input', debounce(function () { updateCartAttribute('Delivery Destination', otherAddress.value || 'Other Business or Address'); }, 600));

    if (occasion) {
      occasion.addEventListener('change', function () {
        const value = occasion.value;
        applyOccasionUI(value);
        if (value === 'Other') {
          updateCartAttribute('Occasion', occasionOther && occasionOther.value ? occasionOther.value : 'Other');
        } else {
          updateCartAttribute('Occasion', value);
        }
      });
    }
    if (occasionOther) occasionOther.addEventListener('input', debounce(function () { updateCartAttribute('Occasion', occasionOther.value || 'Other'); }, 600));
    if (cardMessage) cardMessage.addEventListener('input', debounce(function () { updateCartAttribute('Card Message', cardMessage.value); }, 600));
    if (otherNotes) otherNotes.addEventListener('input', debounce(function () { updateCartAttribute('Other Notes', otherNotes.value); }, 600));

    // ===== Phase 8: re-sync when Dawn updates the cart (remove/qty change) =====
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            return cleanOrphanedItemAttributes(cart).then(function () {
              return fetch('/cart.js').then(function (r) { return r.json(); });
            });
          })
          .then(function (freshCart) {
            const chosen = [].slice.call(fulfillmentRadios).find(function (r) { return r.checked; });
            if (chosen && chosen.value === 'Split Order') {
              renderSplitItems(freshCart);
            }
            if (!freshCart.items || freshCart.items.length === 0) {
              if (body) body.hidden = true;
              if (checkbox) checkbox.checked = false;
            }
          })
          .catch(function (err) {
            console.error('[gift-form] cart sync error:', err);
          });
      });
    }

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftForm);
  } else {
    initGiftForm();
  }
})();